/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrgExtRegisterProfileModel } from '../../models/org-ext-register-profile-model';
import { OrgExtRegisterProfileResultModel } from '../../models/org-ext-register-profile-result-model';

export interface OrgExtRegisterProfileOrganizationIdPost$Params {

/**
 * The organization identifier from the route.
 */
  organizationId: string;
  
    /**
     * Registration details.
     */
    body?: OrgExtRegisterProfileModel
}

export function orgExtRegisterProfileOrganizationIdPost(http: HttpClient, rootUrl: string, params: OrgExtRegisterProfileOrganizationIdPost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<OrgExtRegisterProfileResultModel>> {
  const rb = new RequestBuilder(rootUrl, orgExtRegisterProfileOrganizationIdPost.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<OrgExtRegisterProfileResultModel>;
    })
  );
}

orgExtRegisterProfileOrganizationIdPost.PATH = '/OrgExt/RegisterProfile/{organizationId}';
